export default {
  data() {
    return {
      error: {
        message: ''
      },
      formErrors: {}
    };
  },
  methods: {
    handleError(err) {
      if (err.response) {
        let message = '';
        if (err.response.data) {
          message = err.response.data.msg;
        }
        if (err.response.status === 404) {
          this.$router.push({ name: '404', params: { error: message } });
        } else if (
          err.response.status === 401 &&
          err.response.data.error_code !== 'error_active_user'
        ) {
          this.$router.push({ name: '401', params: { error: message } });
        } else if (err.response.status === 500) {
          this.$router.push({ name: '500' });
        } else if (
          err.response.status === 400 ||
          (err.response.status === 401 &&
            err.response.data.error_code === 'error_active_user')
        ) {
          this.error.message = message;
          if (err.response.data) {
            const code = err.response.data.error_code;
            if (code === 'error_validation') {
              this.formErrors = err.response.data.data;
              return {
                messageCode: code,
                message,
                errors: err.response.data.data
              };
            } else {
              return { errors: { message } };
            }
          }
        }
      } else {
        const message = 'Terjadi suatu kekeliruan';
        this.error.message = message;
        return { errors: { message } };
      }
    },
    clearError() {
      this.error.message = '';
      this.formErrors = {};
    }
  }
};
